import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import { ToastContainer, toast } from "react-toastify";
import { getAccounts } from "./Allaccounts";
import axios from "axios";
import { Button } from "react-bootstrap";
import { FaFilePdf } from "react-icons/fa";

const Admins = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const navigate = useNavigate();
  const [accountStatus, setAccountStatus] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [accountToUpdate, setAccountToUpdate] = useState(null);
  const [allFiles, setAllFiles] = useState({
    bankFile: "",
    aadharFontFile: "",
    aadharBackFile: "",
    panFile: "",
  });

  const handleUpdateClose = () => setShowUpdate(false);

  // Authentication
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const getData = async ({ token, type }) => {
    const accountsarr = [];
    const response = await getAccounts(token);
    setAccountStatus(response?.status);
    response?.accounts?.map((accounts) => {
      if (accounts?.userType === type) {
        accountsarr.push(accounts);
      }

      return 0;
    });

    setAccounts(accountsarr);
  };

  useEffect(() => {
    getData({ token, type: "admin" });
  }, [token]);

  const handleUpdate = (account) => {
    setAllFiles({
      bankFile: `${process.env.REACT_APP_API_URL}/src/upload/bankfile/${account.userInfo.bankFile}`,
      aadharFontFile: `${process.env.REACT_APP_API_URL}/src/upload/aadharfile/${account.userInfo.aadharfrontFile}`,
      aadharBackFile: `${process.env.REACT_APP_API_URL}/src/upload/aadharfile/${account.userInfo.aadharbackFile}`,
      pan: `${process.env.REACT_APP_API_URL}/src/upload/panfile/${account.userInfo.panFile}`,
    });
    setAccountToUpdate(account);
    setShowUpdate(true);
  };

  const updateStatus = async (isActive) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, isActive: isActive },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        toast.warn(message);
      } else {
        // handleUpdateClose()
        toast.success("User status updated successfully");
        // getData(token)
      }
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  const updateRole = async (userType) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, userType: userType },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        toast.warn(message);
      } else {
        // handleUpdateClose()
        toast.success("User status updated successfully");
        // getData(token)
      }
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  const handelSave = async () => {
    try {
      handleUpdateClose();
      getData({ token, type: "admin" });
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const handlePdfOpen = (url) => {
    setShowUpdate(false);
    setPdfUrl(url);
    setShowPdfModal(true);
  };

  const closeModel = () => {
    setShowPdfModal(false);
    setShowUpdate(true);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 p-0">
            <Sidebar
              toggleSidebar={toggleValue}
              setToggleValue={setToggleValue}
            />
          </div>
          <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
            <Icon.ArrowRight
              onClick={() => setToggleValue(true)}
              className="my-5 sidebar-open"
              color="black"
              size={30}
            ></Icon.ArrowRight>
            <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
              <div className="col-12 mb-4">
                <h5>Accounts</h5>
                <h6 className="text-muted">View & manage accounts</h6>
              </div>
              <div className="col-12 mb-5">
                <Table striped bordered hover responsive="md">
                  <thead className="text-center">
                    <tr>
                      <th>ID</th>
                      <th>Picture</th>
                      <th>Name</th>
                      <th>Email id</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountStatus === "success" ? (
                      accounts.map((account, i) => {
                        return (
                          <tr key={i}>
                            <td>{parseInt(i) + 1}</td>
                            <td>
                              <img
                                className="order-list-product-image"
                                src={`${process.env.REACT_APP_API_URL +
                                  process.env.REACT_APP_profile_IMAGE_URL +
                                  account.profilePhoto
                                  }`}
                                alt=""
                              />
                            </td>
                            <td>{account?.name}</td>
                            <td>{account?.email}</td>
                            <td>{account?.userType}</td>
                            <td className="text-center">
                              {account.isActive === 1 ? (
                                <span className="badge rounded-pill text-bg-success">
                                  Active
                                </span>
                              ) : account.isActive === 2 ? (
                                <span className="badge rounded-pill text-bg-warning">
                                  Pending
                                </span>
                              ) : (
                                <span className="badge rounded-pill text-bg-secondary">
                                  Inactive
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <button
                                onClick={() => handleUpdate(account)}
                                className="btn btn-sm btn-success"
                              >
                                <Icon.Pencil />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <td colSpan="8" className="text-center p-5">
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </td>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Account Update Modal */}
      <Modal
        show={showUpdate}
        onHide={handleUpdateClose}
        size="lg"
        key={accountToUpdate ? accountToUpdate.id : "modal"}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <Icon.PencilSquare color="black" size={40} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {accountToUpdate && (
            <Container>
              <Row>
                <Col xs={8} md={4}>
                  <Image
                    style={{ borderRadius: "50%", width: "200px", height: "200px", objectFit: "cover" }}
                    src={`${process.env.REACT_APP_API_URL +
                      process.env.REACT_APP_profile_IMAGE_URL +
                      accountToUpdate.profilePhoto
                      }`}
                    fluid
                    className="img-fluid border border-3"
                    onError={(e) => {
                      e.target.src = "https://pronedvizhimost.ru/static/custom/img/default/user.png"
                    }}
                  />
                </Col>
                <Col xs={4} md={8}>
                  <h5>
                    Name:<span className="ms-2">{accountToUpdate.name}</span>
                  </h5>
                  <h6 className="text-dark">
                    Email:<span className="ms-2">{accountToUpdate?.email}</span>
                  </h6>
                  <h6 className="text-muted">
                    Role:
                    <span className="ms-2">{accountToUpdate?.userType}</span>
                  </h6>
                  <section className="mt-4 border border-2 p-1 rounded d-flex">
                    <h5>Address:</h5>
                    <span className="ms-2">
                      {accountToUpdate.userInfo
                        ? "City: " +
                        accountToUpdate?.userInfo?.city +
                        ",  " +
                        "State: " +
                        accountToUpdate?.userInfo?.state +
                        ",  " +
                        "Zip Code: " +
                        accountToUpdate?.userInfo?.zip +
                        ",  " +
                        "Full Address: " +
                        accountToUpdate?.userInfo?.address +
                        ",  " +
                        "Phone no: " +
                        accountToUpdate?.userInfo?.number
                        : "Address is empty"}
                    </span>
                  </section>
                  <Row className="mt-4">
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Bank Name :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.bankName
                            ? accountToUpdate?.userInfo?.bankName
                            : "Bank name is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Branch Name :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.branchName
                            ? accountToUpdate?.userInfo?.branchName
                            : "Branch name is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>IFSC Code :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.ifscCode
                            ? accountToUpdate?.userInfo?.ifscCode
                            : "IFSC code is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Account No :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.accountNumber
                            ? accountToUpdate?.userInfo?.accountNumber
                            : "Account Number is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <strong className="mb-1 d-block">Bank Statement</strong>
                      {allFiles.bankFile ? (
                        <Button
                          variant="outline-primary"
                          onClick={() => handlePdfOpen(allFiles.bankFile)}
                        >
                          <FaFilePdf className="me-2" /> Bank file
                        </Button>
                      ) : (
                        <span className="text-muted">No file available</span>
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Row className="mt-4">
                      <Row>
                        <Col xs={12} md={12}>
                          <h6>
                            <strong>Aadhar No:</strong>
                            <span className="ms-2 text-muted">
                              {accountToUpdate?.userInfo?.aadharNumber
                                ? accountToUpdate?.userInfo.aadharNumber
                                : "No is empty"}
                            </span>
                          </h6>
                          <Row>
                            <Col xs={6} md={6}>
                              {allFiles.aadharFontFile ? (
                                <Button
                                  variant="outline-primary"
                                  onClick={() =>
                                    handlePdfOpen(allFiles.aadharFontFile)
                                  }
                                >
                                  <FaFilePdf className="me-2" /> Aadhar front
                                  file
                                </Button>
                              ) : (
                                <span className="text-muted">
                                  No file available
                                </span>
                              )}
                            </Col>
                            <Col xs={6} md={6}>
                              {allFiles.aadharBackFile ? (
                                <Button
                                  variant="outline-primary"
                                  onClick={() =>
                                    handlePdfOpen(allFiles.aadharBackFile)
                                  }
                                >
                                  <FaFilePdf className="me-2" /> Aadhar Back
                                  file
                                </Button>
                              ) : (
                                <span className="text-muted">
                                  No file available
                                </span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col xs={6} md={6}>
                          <h6>
                            <strong>Pan No:</strong>
                            <span className="ms-2 text-muted">
                              {accountToUpdate?.userInfo?.panNumber
                                ? accountToUpdate?.userInfo?.panNumber
                                : "No is empty"}
                            </span>
                          </h6>

                          {allFiles.pan ? (
                            <Button
                              variant="outline-primary"
                              onClick={() => handlePdfOpen(allFiles.pan)}
                            >
                              <FaFilePdf className="me-2" /> Pan file
                            </Button>
                          ) : (
                            <span className="text-muted">
                              No file available
                            </span>
                          )}
                        </Col>
                      </Row>
                    </Row>
                    <Row className="mt-3">
                      <Col xs={6} md={6}>
                        <h6>Change Status</h6>
                        <select
                          onChange={(e) => updateStatus(e.target.value)}
                          className="form-select shadow-none"
                          aria-label="Default select example"
                        >
                          {accountToUpdate.isActive === 1 && (
                            <option selected disabled>
                              Active
                            </option>
                          )}
                          {accountToUpdate.isActive === 2 && (
                            <option selected disabled>
                              Pending
                            </option>
                          )}
                          {accountToUpdate.isActive === 0 && (
                            <option selected disabled>
                              Inactive
                            </option>
                          )}
                          <option value="1">Active</option>
                          <option value="2">Pending</option>
                          <option value="0">Inactive</option>
                        </select>
                      </Col>
                      <Col xs={6} md={6}>
                        <h6>Change Role</h6>
                        <select
                          onChange={(e) => updateRole(e.target.value)}
                          className="form-select shadow-none"
                          aria-label="Default select example"
                        >
                          <option selected disabled>
                            {accountToUpdate?.userType}
                          </option>
                          <option value="admin">admin</option>
                          <option value="user">user</option>
                          <option value="distributor">distributor</option>
                        </select>
                      </Col>
                    </Row>
                  </Row>
                </Col>
                <div style={{ textAlign: "right", marginTop: "15px" }}>
                  <Button
                    style={{ width: "100px", padding: "5px" }}
                    onClick={handelSave}
                  >
                    Save
                  </Button>
                </div>
              </Row>
            </Container>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showPdfModal} onHide={closeModel} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>PDF Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={pdfUrl}
            width="100%"
            height="500px"
            style={{ border: "none" }}
            title="PDF Viewer"
          ></iframe>
        </Modal.Body>
      </Modal>

      <ToastContainer theme="dark" autoClose={2000} />
    </>
  );
};

export default Admins;
